import React, { FC } from 'react'

import { IconAntiShockProps } from './IconAntiShock.types'
import * as Styled from './styles/IconAntiShock.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAntiShock: FC<IconAntiShockProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAntiShockProps['size'],
  isResponsive = false,
}: IconAntiShockProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#fc8c93d4-4590-4894-bd32-ee48ebce89db__a)' strokeLinecap='round' strokeWidth='2'>
          <path
            d='M33 28.328a2.368 2.368 0 0 1-1.675 2.897L22.462 33.6a2.368 2.368 0 0 1-2.897-1.673L14 11.122a2.367 2.367 0 0 1 1.662-2.897l11.15-2.975L33 28.372m-9.302 1.108 4.477-1.2'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M15.02 28.933H8.985l5.575 4.312-4.33 4.71L17 36.932v6l4.805-5.472 5.707 3.428-1.364-4.956'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='fc8c93d4-4590-4894-bd32-ee48ebce89db__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconAntiShock
